import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";

import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import AssetsPage from "./pages/AssetsPage";
import UploadPage from "./pages/UploadPage";
import WillPage from "./pages/WillPage";

function AppContent(){

const location = useLocation();

const hideNavbar =
location.pathname === "/" ||
location.pathname === "/login" ||
location.pathname === "/register";

return(

<>
{!hideNavbar && <Navbar />}

<Routes>

<Route path="/" element={<LandingPage />} />

<Route path="/login" element={<LoginPage />} />

<Route path="/register" element={<RegisterPage />} />

<Route path="/dashboard" element={<DashboardPage />} />

<Route path="/assets" element={<AssetsPage />} />

<Route path="/upload" element={<UploadPage />} />

<Route path="/will" element={<WillPage />} />

</Routes>

</>

)

}

function App(){
return(
<Router>
<AppContent />
</Router>
)
}

export default App;